<template>
    <v-layout pa-0 ma-0 row justify-space-between v-if="scenario" style="height: 28px">
        <v-flex xs6 class="d-inline-flex align-center">
            <div v-if="showLocation" class="location-row text-left ma-0"> {{scenario.location}} </div>
        </v-flex>
        <v-flex xs6 class="d-inline-flex justify-end align-center">
            <div v-if="edit"  class="edit-btn ml-2" @click.stop.prevent="openEditScenario">
                <v-img max-height="18px" max-width="18px" :src="require('@/assets/icons/edit_icon.svg')" class="d-inline-flex"/>
            </div>
            <div v-if="edit" class="edit-btn ml-2" @click="openDeleteScenario">
                <v-img :src="require('@/assets/icons/close_icon.svg')" class="d-inline-flex"/>
            </div>
        </v-flex>
        <ModalDeleteConfirm
            v-model="deleteScenario"
            :url="`/scenarios/hotel-admin/scenarios/${scenario.uid}/`"
            :close="closeDeleteScenario"
        >
            <template #deleteTitle>
                Вы действительно хотите удалить <br> сценарий?
            </template>
            <template #deleteSubtitle>
                После удаления сценарий<br>
                <span class="common-text">{{scenario.name}}</span>
                <span v-if="scenario.location" class="grey-text ml-1">({{scenario.location}})</span><br>
                пропадёт из списка сценариев
            </template>
        </ModalDeleteConfirm>
    </v-layout>
</template>

<script>
import ModalDeleteConfirm from "@/components/modals/ModalDeleteConfirm";

export default {
    name: "ScenarioStatus",
    components: {ModalDeleteConfirm},
    props: {
        scenario: {
            type: [Array, Object],
            default: null,
        },
        edit: {
            type: Boolean,
            default: false,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            modalDelete: false,
            deleteScenario: false,
            room: null,
        };
    },
    created() {
        this.room = this.$route.params.id;
    },
    methods: {
        openEditScenario() {
            this.$router.push({
                name: "scenariopage",
                query: {
                    scenario: this.scenario.uid
                },
                params: {
                    id: this.room
                },
            });
        },
        openDeleteScenario() {
            this.deleteScenario = true;
        },
        closeDeleteScenario() {
            this.deleteScenario = false;
        },
    },
}
</script>